import { i18nFactory } from '@lib/i18n';

const ru = {
    index: 'Главная страница',
    publicationNew: 'Добавить объявление',
    auth: 'Войти',
    account: 'Личный кабинет',
    theme: 'Тёмная тема',
    settings: 'Настройки',
    notify: 'Уведомления',
};

const en = {
    index: 'Main page',
    publicationNew: 'New publication',
    auth: 'Log in',
    account: 'Personal account',
    theme: 'Dark theme',
    settings: 'Settings',
    notify: 'Notifications',
};

const ka = {
    index: 'მთავარი გვერდი',
    publicationNew: 'რეკლამის დასამატებლად',
    auth: 'შეიყვანეთ',
    account: 'პირადი ანგარიში',
    theme: 'ბნელი თემა',
    settings: 'პარამეტრები',
    notify: 'შეტყობინებები',
};

export const i18n = i18nFactory({ ru, en, ka });
